import React from 'react'
import SignUpCard from '../components/SignUpCard'

function SignUpPage() {
  return (
    <div className="bg-black">
      <SignUpCard/>
    </div>
  )
}

export default SignUpPage
